<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="title">反馈详情：</div>
        <div class="box">
          <div class="label">发布人ID：</div>
          <div>
            {{info.uid}}
          </div>
        </div>
        <div class="box">
          <div class="label">昵称：</div>
          <div>
            {{info.nickname}}
          </div>
        </div>
        <div class="box">
          <div class="label">发布时间：</div>
          <div>
            {{info.created}}
          </div>
        </div>
        <div class="box">
          <div class="label">详情：</div>
          <div>
            {{info.content}}
          </div>
        </div>
        <div class="box">
          <div class="label">配图：</div>
          <el-image
            style="width: 80px; height: 80px;margin-right: 10px;"
            :src="item"
            v-for="(item, index) in info.pics"
            :preview-src-list="info.pics"
            :key="index"
            fit="contain"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '反馈详情'
      },
      content: '',
      pics: [],
      info: {}
    };
  },
  mounted() {
    // 获取列表
    this.id = this.$route.query.id;
    this.getInfo();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getInfo() {
      this.loading++;
      this.httpGet(this.$root.getFeedbackInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          this.info = res;
          // this.content = res.content;
          // this.pics = res.pics;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;
      .title{
        word(18px, #333);
      }
      .box{
        word(14px, #666);
        margin-top: 40px;
        flex-x(flex-start, flex-start);
        .label{
          width: 80px;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
